const baseImagePath = "/images/socials/";

export const socials = [
	{
		link: "https://zealy.io/c/magicyearn",
		imagePath: baseImagePath + "zealy.svg",
		altText: "Magic Yearn Zealy",
		color: "#000000"
	},
	{
		link: "https://discord.gg/YRA4ykgwt2",
		imagePath: baseImagePath + "discord.svg",
		altText: "Magic Yearn Discord",
		color: "#5865f2"
	},
	{
		link: "https://t.me/magicyearn",
		imagePath: baseImagePath + "telegram.svg",
		altText: "Magic Yearn Telegram",
		color: "#25a3e2"
	},
	{
		link: "https://twitter.com/MagicYearn",
		imagePath: baseImagePath + "twitter.svg",
		altText: "Magic Yearn Twitter",
		color: "#1D9BF0"
	},
	{
		link: "https://medium.com/@desirable_oruby_frog_727",
		imagePath: baseImagePath + "medium.svg",
		altText: "Magic Yearn Medium",
		color: "#000000"
	},
	{
		link: "https://www.coingecko.com/de/munze/magic-yearn-share",
		imagePath: baseImagePath + "coingecko.svg",
		altText: "Magic Yearn Coingecko",
		color: "#8bc53f"
	}
];